import { Link } from "@/lib/router-compat";
import { ArrowRight, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";

export const CTASection = () => {
  return (
    <section className="relative py-16 lg:py-24 bg-foreground text-background overflow-hidden">
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-3xl lg:text-4xl font-heading font-bold mb-6">
            READY TO PROTECT YOUR HOME?
          </h2>
          <p className="text-lg text-background/80 mb-8 leading-relaxed">
            Whether you need a new roof, siding, windows, or storm damage repair — get a free estimate from our experienced team today.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link to="/contact">
              <Button size="lg" className="bg-secondary hover:bg-secondary/90 text-secondary-foreground font-semibold font-subheading px-8">
                Get a Free Estimate <ArrowRight className="w-5 h-5 ml-2" aria-hidden="true" />
              </Button>
            </Link>
            <a href="tel:6519831609">
              <Button size="lg" variant="outline" className="border-background/50 text-background hover:bg-background hover:text-foreground font-semibold font-subheading px-8 bg-transparent">
                <Phone className="w-5 h-5 mr-2" /> (651) 983-1609
              </Button>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
